export default __webpack_public_path__ + "static/platform-app-store-fd385965c352757b036056969184cc62.png";